export default function () {
    /**
     * Клик по селектору с выбором количества товара
     */
    $(document).on('click', '.app-product-count-selector button', function (e) {
        e.preventDefault();
        const $root = $(this).closest('.app-product-count-selector');
        const sign = parseInt($(this).data('sign'), 10);
        const $count = $root.find('input');
        let value = parseInt($count.val(), 10) + sign;
        if ($count.data('max-count') > 0 && value > parseInt($count.data('max-count'), 10)) {
            value = $count.data('max-count');
        }
        $count
            .val(value)
            .trigger('change');
    });

    $(document).on('change', '.app-product-count-selector input', function () {
        if ($(this).val() < 1) {
            if ($(this).data('min-count') >= 0) {
                $(this).val($(this).data('min-count'));
            } else {
                $(this).val(1);
            }
        }
        if ($(this).data('max-count') > 0 && parseInt($(this).val(), 10) > parseInt($(this).data('max-count'), 10)) {
            $(this).val($(this).data('max-count'));
        }
        // для кнопки купить поменяем количество товара
        $('[data-product-id=' + $(this).closest('.app-product-count-selector').data('product-id') + ']')
            .data('product-count', $(this).val());
    });
}
